import { DarwinFlex } from 'components/darwin-ui';
import Icon, { IconName } from 'components/darwin-ui/Icon';
import DarwinTypography from 'components/darwin-ui/Typography';
import styles from './index.module.css';

interface CollapseItemProps {
  icon: IconName;
  label: string;
  isHeader?: boolean;
  selected?: boolean;
  onClick?: () => void;
}

export const CollapseItem = ({
  icon,
  label,
  isHeader,
  selected,
  onClick,
}: CollapseItemProps) => {
  return (
    <div
      className={!isHeader ? styles.collapseItemContainer : ''}
      onClick={onClick}
      style={{ cursor: !isHeader ? 'pointer' : 'default' }}
    >
      <DarwinFlex
        align="center"
        className={`
          ${styles.collapseItem} 
          ${!isHeader ? styles.collapseItemChildren : ''}
        `}
      >
        <Icon
          name={icon}
          size="lg"
          fill="none"
          className={selected ? styles.selectedItemIcon : styles.itemIcon}
        />
        <DarwinTypography.Text
          className={`${styles.collapseItemLabel}
            ${selected ? styles.selectedItemText : ''}
          `}
          strong
        >
          {label}
        </DarwinTypography.Text>
      </DarwinFlex>
    </div>
  );
};
